<template>
  <Router-view name="default" v-slot="{ Component, route }">
    <Transition name="fade" :key="route.path">
      <Suspense>
        <component :is="Component" :key="route.path" />

        <template #fallback>
          <div>
            <div class="container">
              <div class="top-bar">
                <div class="break-points">
                  <img class="logo" src="./assets/images/logo_cubo.png" />
                </div>
                
              </div>

              <div class="content">
                <div class="side-bar" >
                  <div class="sider-bar-menu">
                    <div class="flex">
            
                    </div>
                  </div>
                  <div>

                  </div>
                </div>
              </div>
            </div>
            <Loading :active="true" :can-cancel="false" :is-full-page="true">
              <template #default>
                <div class="spinner spinner--cube-grid" style="width: 60px; height: 60px;">
                  <div class="sk-cube sk-cube1" style="background-color: #032e3f; animation-duration: 1.3s;"></div>
                  <div class="sk-cube sk-cube2" style="background-color: #032e3f; animation-duration: 1.3s;"></div>
                  <div class="sk-cube sk-cube3" style="background-color: #032e3f; animation-duration: 1.3s;"></div>
                  <div class="sk-cube sk-cube4" style="background-color: #032e3f; animation-duration: 1.3s;"></div>
                  <div class="sk-cube sk-cube5" style="background-color: #032e3f; animation-duration: 1.3s;"></div>
                  <div class="sk-cube sk-cube6" style="background-color: #032e3f; animation-duration: 1.3s;"></div>
                  <div class="sk-cube sk-cube7" style="background-color: #032e3f; animation-duration: 1.3s;"></div>
                  <div class="sk-cube sk-cube8" style="background-color: #032e3f; animation-duration: 1.3s;"></div>
                  <div class="sk-cube sk-cube9" style="background-color: #032e3f; animation-duration: 1.3s;"></div>
                </div>
              </template>
              <template #after>
                <h3>Carregando Landing</h3>
              </template>
            </Loading>
          </div>
        </template>
      </Suspense>
    </Transition>
  </Router-view>
</template>

<script setup>
import { ref } from "vue";
import Loading from "vue-loading-overlay";
</script>

<style>
#app {
  font-family: "Nunito", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>
